import { Chip, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { FlagIcon } from "react-flag-kit";
import { countryToCode } from "../../utils/country_code_mapping";

type IconTextRowProps = {
    title: string;
    IconComponent: React.ElementType;
    // Either a single value (existing usage, unchanged) or a list of tag-like values -
    // pass `chips` to render each as a small Chip instead of one line of text, which reads much
    // better for semicolon-separated multi-value fields (regions, donors, keywords, etc.).
    displayText?: string | number;
    chips?: string[];
    country?: string;
    iconColor?: string;
}

function IconTextRow({title, IconComponent, displayText, chips, country, iconColor = 'action.active'}: IconTextRowProps) {
    return(
        <Grid item container direction="row" alignItems="flex-start" wrap="nowrap">
            <Tooltip title={title}>
                <IconButton sx={{ padding: '10px'}} size="small">
                    {country !== undefined
                    ? (countryToCode[country] !== undefined
                        ? <div>
                            <FlagIcon code={countryToCode[country]} size={22}/>
                          </div>
                        : <IconComponent sx={{ color: iconColor }} fontSize="small" />)
                    : <IconComponent sx={{ color: iconColor }} fontSize="small" />}
                </IconButton>
            </Tooltip>
            {chips ? (
                chips.length > 0 ? (
                    <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ paddingTop: '9px' }}>
                        {chips.map((chip, index) => (
                            <Chip key={`${chip}-${index}`} label={chip} size="small" variant="outlined" />
                        ))}
                    </Stack>
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ paddingTop: '9px' }}>-</Typography>
                )
            ) : (
                <Typography variant="body1" sx={{ paddingTop: '9px' }}>{displayText}</Typography>
            )}
        </Grid>
    )
}

export default IconTextRow;